import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component, computed,
    inject, input,
    ViewEncapsulation
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TariffStore } from '../../../../tariff';
import { GtmService } from '@seven1/angular/gtm';
import { ITariffToggleBlok } from './tariff-toggle.model';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';

@Component({
    selector: 'app-tariff-toggle',
    imports: [NgClass, MatIconModule],
    providers: [],
    templateUrl: './tariff-toggle.component.html',
    styleUrls: ['./tariff-toggle.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': 'getDisplayClasses()',
    }
})
export class TariffToggleComponent {
    private _tailwind = inject(TailwindService);
    private _gtmService = inject(GtmService);
    tariffStore = inject(TariffStore);

    block = input.required<ITariffToggleBlok>();

    getOuterClasses = computed<string[]>(() => {
        const block = this.block();
        return [
            'block',
            'cursor-pointer',
            ...this._tailwind.getSpacingClasses(block),
        ];
    });

    getDisplayClasses = computed<string[]>(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });

    public click(tarifPicked: 'single' | 'family') {
        this.tariffStore.tariff = tarifPicked;
        const block = this.block();
        switch (tarifPicked) {
            case 'family':
                if (block.gtm_click_family_event_name?.length) {
                    this._gtmService.logEvent(block.gtm_click_family_event_name, 'tariff_selection_change', 'click', undefined, {tariff: this.tariffStore.tariff, size: this.tariffStore.size});
                }
                break;
            case 'single':
                if (block.gtm_click_single_event_name?.length) {
                    this._gtmService.logEvent(block.gtm_click_single_event_name, 'tariff_selection_change', 'click', undefined, {tariff: this.tariffStore.tariff, size: this.tariffStore.size});
                }
                break;
        }
    }

    public toggle() {
        this.tariffStore.tariff =
            this.tariffStore.tariff === undefined
                ? 'family'
                : this.tariffStore.tariff === 'single'
                    ? 'family'
                    : 'single';
        const block = this.block();
        switch (this.tariffStore.tariff) {
            case 'family':
                if (block.gtm_click_family_event_name?.length) {
                    this._gtmService.logEvent(block.gtm_click_family_event_name, 'tariff_selection_change', 'click', undefined, {tariff: this.tariffStore.tariff, size: this.tariffStore.size});
                }
                break;
            case 'single':
                if (block.gtm_click_single_event_name?.length) {
                    this._gtmService.logEvent(block.gtm_click_single_event_name, 'tariff_selection_change', 'click', undefined, {tariff: this.tariffStore.tariff, size: this.tariffStore.size});
                }
                break;
        }
    }
}
